import brandLogo from '../../assets/logo-transparent.png'

export default function BrandMark({ compact = false }) {
  return (
    <div
      className={`overflow-hidden ${
        compact
          ? 'h-16 w-full'
          : 'h-[clamp(82px,10vw,124px)] w-[min(100%,460px)]'
      }`}
    >
      <img
        src={brandLogo}
        alt="HNTM PreNexus"
        className="size-full object-cover object-center"
      />
    </div>
  )
}
